import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { MatIconModule } from  '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from  '@angular/material/toolbar';
import { MatDialogModule } from  '@angular/material/dialog';
import { MatTableModule } from  '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatNativeDateModule, MAT_DATE_LOCALE, MatDateFormats, MAT_DATE_FORMATS, DateAdapter} from '@angular/material/core';
import {TextFieldModule} from '@angular/cdk/text-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from '../environments/environment';

import { TendersComponent } from './components/tenders/tenders.component';
import { TenderComponent } from './components/tender/tender.component';
import { SearchResultComponent } from './components/search-result/search-result.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegistrationComponent } from './components/registration/registration.component';
import { QuestionsComponent } from './components/questions/questions.component';
import { ShareDataServiceService } from './services/share-data-service.service';
import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    const day = this._to2digit(date.getDate());
    const month = this._to2digit(date.getMonth() + 1); // Months are 0-based
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  }

  private _to2digit(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  parse(value: any): Date | null {
    if (typeof value === 'string') {
      const splitChar:string = value.indexOf('.')>-1?'.':'/';
      const parts = value.split(splitChar);
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Zero-based month
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return super.parse(value);
  }
}

const custom_date_formats: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM', // Parsing format
  },
  display: {
    dateInput: 'DD/MM', // Display format
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    TendersComponent,
    TenderComponent,
    SearchResultComponent,
    RegistrationComponent,
    QuestionsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatIconModule,
    MatInputModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatToolbarModule,
    MatDialogModule ,
    MatTableModule,
    MatRadioModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    TextFieldModule,
    RecaptchaV3Module,
    MatProgressSpinnerModule
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'he-IL'},
    { provide: DateAdapter, useClass: CustomDateAdapter },
    ShareDataServiceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
